import React, { useState } from 'react';
import { Button } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import CallDialer from '../call/CallDialer';
import PatientPhoneModal from './PatientPhoneModal';
import { logEvent } from '../../analytics';

const PatientCallButton = ({ patient, onCallEnded, onPatientUpdate }) => {
  const { t } = useTranslation();
  const [showDialer, setShowDialer] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);

  const mobile = patient?.getMobileNumber?.();
  const canCall = Boolean(mobile);

  const handleEnded = () => {
    setShowDialer(false);
    onCallEnded?.();
  };

  const handleClick = () => {
    logEvent("PatientDetails", "Call");
    if (canCall) {
      setShowDialer(true);
    } else {
      setShowPhoneModal(true);
    }
  };

  const handlePhoneSaved = (updatedPatient) => {
    onPatientUpdate?.(updatedPatient);
    setShowDialer(true);
  };

  return (
    <>
      <Button
        icon={<PhoneOutlined className="rotated-icon" />}
        onClick={handleClick}
        type="default"
      >
        {t('patient_details.call')}
      </Button>

      {showDialer && (
        <CallDialer
          patient={patient}
          onCallEnded={handleEnded}
        />
      )}

      <PatientPhoneModal
        open={showPhoneModal}
        onClose={() => setShowPhoneModal(false)}
        patient={patient}
        onPhoneSaved={handlePhoneSaved}
      />
    </>
  );
};

export default PatientCallButton;
